export function getChecklistItemFormSubmitDisabled({
  initialValue,
  isLoading,
  text,
}) {
  return !text || text === initialValue || isLoading
}
